package amazon.lastmile.inject

import app.nestbridge.feature.home.ui.HomeUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = HomeUiFactory::class)
public interface AppNestbridgeFeatureHomeUiHomeUiFactory {
  @Provides
  @IntoSet
  public fun provideHomeUiFactoryFactoryMultibinding(homeUiFactory: HomeUiFactory): Ui.Factory = homeUiFactory
}
